import Vue from 'vue';
import Router from 'vue-router';
import TicketScanner from '../components/TicketScanner';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'ticket-scanner',
      component: TicketScanner,
    },
  ],
});
